import Cart from '../Cart';
import React from 'react';

const RenderCartSection = ({
  payload,
  errors,
  cart,
  removeOrderRow,
  updateOrderRowQuantity,
  setBonus,
  enjoyClub,
}) => {
  const {
    bonusImage,
    bonusUsed,
    bonusToEarn,
    bonusBalance,
    customerDetails,
    orderCurrency,
    authenticated,
    errorMessage,
    isBusinessCustomer,
    enjoyClubDescription,
  } = payload;
  const { bonus } = customerDetails;

  return (
    <>
      <div>
        {errors && errors['cart'] && (
          <p className="checkout__validator--error">{errors['cart'][0]}</p>
        )}
      </div>
      <Cart
        {...{
          ...cart,
          removeOrderRow,
          authenticated,
          updateOrderRowQuantity,
          bonusToEarn,
          bonusBalance,
          bonusImage,
          bonusUsed,
          isBusinessCustomer,
          errorMessage,
          orderCurrency,
          bonus,
          enjoyClub,
          enjoyClubDescription,
        }}
        onSetBonus={setBonus}
      />
    </>
  );
};

export default RenderCartSection;
